import './RssFeed.scss';

import { faLocationDot, faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../utils/api';
import CandidateJobPostingModal from "./modals/CandidateJobPostingModal";

export default function JobsPage() {
  const { rss_feed_id } = useParams();

  const [jobs, setJobs]                       = useState([]);
  // const [selectedJob, setSelectedJob]         = useState(null);
  const [jobToEdit, setJobToEdit]             = useState(null);
  const [page, setPage]                       = useState(1);
  const [hasMore, setHasMore]                 = useState(true);
  const perPage = 10;

  // Fetch jobs whenever debouncedSearch or page changes
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const { data } = await api.get(`/candidate_job_postings?rss_feed_id=${rss_feed_id}&page=${page}&per_page=${perPage}`);

        if (page === 1) {
          setJobs(data);
        } else {
          setJobs(prev => [...prev, ...data]);
        }

        // If fewer than perPage jobs came back, no more pages
        if (data.length < perPage) {
          setHasMore(false);
        }
      } catch (err) {
        console.error('Error fetching jobs:', err);
      }
    };

    fetchJobs();
  }, [page, rss_feed_id]);

  const label = async (id, valid) => {
    setJobs(prevJobs =>
      prevJobs.map(job =>
        job.id === id ? { ...job, valid: valid } : job
      )
    );

    api.put(`/candidate_job_postings/${id}`, {valid});
  };

  return (
    <div className='__jobs'>
      <div className='content'>
        <div className='header'>
          <div className='primary'>
            RSS Feed
          </div>
        </div>

        <div className='bottom-section'>
          <div className='search-results'>
            {jobs.map((job) => (
              <div key={job.id} className='job-card'>
                <div className='job-header'>
                  <div className='job-title'>{job.title}</div>
                  {false &&
                    <button className='edit ppy-btn ppy-btn-primary' onClick={() => setJobToEdit(job)}>
                      <FontAwesomeIcon icon={faPencil} />
                    </button>
                  }
                </div>

                {job.tags && job.tags.trim() !== '' && (
                  <div className='tags'>
                    {job.tags.split(',').map((tag, idx) => (
                      <div key={idx} className='tag'>
                        {tag.trim()}
                      </div>
                    ))}
                  </div>
                )}

                {job.budget &&
                  <div className='budget'>Budget: ${job.budget}</div>
                }

                <div className='body'>{job.description}</div>
                <div className='location'><FontAwesomeIcon icon={faLocationDot} /> {job.location}</div>
                <div className='label'>
                  <button className={classNames('ppy-btn', {'undecided': job.valid === null}, {'green': job.valid === true})} onClick={() => label(job.id, true)}>
                    Yes
                  </button>
                  <button className={classNames('ppy-btn', {'undecided': job.valid === null}, {'ppy-btn-primary': job.valid === false})} onClick={() => label(job.id, false)}>
                    No
                  </button>
                </div>
                {job.predicted_valid !== null &&
                  <div className="prediction">
                    Suggestion: { job.predicted_valid ? 'Yes' : 'No' }
                  </div>
                }
                <div className="dates">
                  <div>Posted {new Date(job.posted_at).toLocaleDateString('en-US')}</div>
                  { job.expires_at &&
                    <div className="expires-at">
                      <div>Expires {new Date(job.expires_at).toLocaleDateString('en-US')}</div>
                      {new Date(job.expires_at) < new Date() && (
                        <div className="expired">Expired</div>
                      )}
                    </div>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
        {hasMore && jobs.length > 0 && (
          <div className="load-more">
            <button
              className="ppy-btn ppy-btn-primary"
              onClick={() => setPage(prev => prev + 1)}
            >
              Load More
            </button>
          </div>
        )}
      </div>

      <CandidateJobPostingModal
        show={jobToEdit !== null}
        handleClose={() => setJobToEdit(null)}
        job={jobToEdit}
        jobs={jobs}
        setJobs={setJobs}
      />
    </div>
  );
}
